import axios from 'axios';


const axiosInstance = axios.create({
  baseURL: '/api',
  timeout: 60000,
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

export default axiosInstance;
